import * as Config from '../../../config';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import './Input.css';

import { FormContext } from '../../../contexts/form-context';
import { setStateShortcuts } from "../shortcut/redux/actions/index";

function ConnectedInputX({
  name, label, type, value, placeholder = null, style,
  onClick = () => {}, modalHasEntered, setStateShortcuts,
  containerClassName, labelClassName, inputClassName, maxLength = 100,
  setValueExternal = null,
  children
}) {
  const { data, set } = useContext(FormContext);

  const [val, setVal] = useState(value);
  const inputRef = useRef(null);
  const [focus, setFocus] = useState(false);
  const prepareFocus = () => {
    setStateShortcuts(false);
    setFocus(true);
  };
  const prepareBlur = () => {
    setFocus(false);
    setStateShortcuts(true);
  }

  const setValue = (e) => {
    setVal(e.target.value);
    const form = { ...data };
    form[name] = e.target.value;
    set({...form});
    if (setValueExternal) { setValueExternal(e.target.value) }
  }

  useEffect(() => {
    if (modalHasEntered) {
      setTimeout(() => {
        inputRef.current.focus()
      }, 100);
    }
  }, [modalHasEntered]);

  const onEnterPress = (e) => {
    if (e.charCode === 13 && val.length > 0) {
      onClick();
    }
  }

  const forceFocus = () => {
    if (Config.TOUCH_ENABLED) {
      inputRef.current.focus()
    }
  }

  return (
    <div className={containerClassName} style={{ ...style }}>
      <span className={labelClassName}>{ label }</span>
      <input name={name} className={inputClassName} ref={inputRef} type={type} onChange={setValue} value={val}
        placeholder={placeholder} onKeyPress={onEnterPress} onFocus={prepareFocus} onBlur={prepareBlur}
        style={{ color: focus ? Config.TYPE_LIGHT : Config.TYPE_SECONDARY }} autoComplete={name}
        maxLength={maxLength}
        onClick={forceFocus} required
      />
      { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child)) }
    </div>
  )
}

ConnectedInputX.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  onClick: PropTypes.func,
  setValueExternal: PropTypes.func,
  maxLength: PropTypes.number
}

const InputX = connect(
  null,
  dispatch => ({
    setStateShortcuts: state => dispatch(setStateShortcuts(state)),
  })
)(ConnectedInputX);

export default InputX;
